<script>
  import { onMount } from "svelte";
  import Items from "./Items.svelte";
  import l from "../scripts/utilities.js";
  import Loader from "./Loader.svelte";

  /**
   * @typedef {Object} Props
   * @property {any} categories
   * @property {any} object1137 - export let items;
   * @property {any} object1138
   * @property {any} object1139
   * @property {any} cats1137
   * @property {any} cats1138
   * @property {any} cats1139
   */

  /** @type {Props} */
  let {
    categories = $bindable(),
    object1137 = $bindable(),
    object1138 = $bindable(),
    object1139 = $bindable(),
    cats1137 = $bindable(),
    cats1138 = $bindable(),
    cats1139 = $bindable(),
  } = $props();

  let loading = $state(1);

  // export let projectResearch;
  function getBaseUrl() {
    let app = document.getElementById("app");
    return app.getAttribute("data-base-url");
  }

  function updateCats(obj, cats) {
    let items = obj.items;
    let out = [];
    let ids = [];
    items.forEach((element) => {
      if (element.categories.length) {
        element.categories.forEach((e) => {
          if (ids.indexOf(e.id) == -1) ids.push(e.id);
        });
      }
    });
    cats.forEach((cat) => {
      if (cat.id == "1176" || cat.id == "1141" || ids.indexOf(cat.id) > -1) out.push(cat);
    });
    return out;
  }
  function updateItems(obj, c) {
    let latest = c.find((o) => {
      return o.id === 1141;
    });
    console.log("latest");
    console.log(latest);
    let items = obj.items;
    if (items.length) {
      items[0].categories.push(latest);
    }
    obj.items = items;
    return obj;
  }

  onMount(async () => {
    let requests = await Promise.all([
      fetch(getBaseUrl() + "categories/archive/"),
      fetch(getBaseUrl() + "archive/1137/"),
      fetch(getBaseUrl() + "archive/1138/"),
      fetch(getBaseUrl() + "archive/1139/"),
    ]);
    categories = await requests[0].json();
    let o1137 = await requests[1].json();
    object1137 = o1137.length ? updateItems(o1137[0], categories) : {};
    cats1137 = o1137.length ? updateCats(o1137[0], categories) : categories;

    let o1138 = await requests[2].json();
    object1138 = o1138.length ? updateItems(o1138[0], categories) : {};
    cats1138 = o1138.length ? updateCats(o1138[0], categories) : categories;

    let o1139 = await requests[3].json();
    object1139 = o1139.length ? updateItems(o1139[0], categories) : {};
    cats1139 = o1139.length ? updateCats(o1139[0], categories) : categories;

    loading = 0;
  });
</script>

<div class="inner">
  {#if loading}
    <Loader message={l("loading")} />
  {:else}
    <Items
      title={object1137.category}
      items={object1137.items}
      categories={cats1137}
      cl={"bg-1137"}
    />
    <Items
      title={object1138.category}
      items={object1138.items}
      categories={cats1138}
      cl={"bg-1138"}
    />
    <Items
      title={object1139.category}
      items={object1139.items}
      categories={cats1139}
      cl={"bg-1139"}
    />
  {/if}
</div>
